/* NEXOWEAR · tramos por cantidad en el carrito.
   Cada producto del catálogo tiene tres variantes en la opción «Cantidad» (1 a 4 / 5 a 19 / 20 o más unidades).
   Este script suma las unidades de cada producto (todas sus tallas y colores) y deja cada línea en la variante del
   tramo que corresponde. Corre al cargar la página, después de cada cambio del carrito y antes de ir a pagar. */
(function () {
  'use strict';
  var OPT = 'Cantidad';
  var TIERS = [{ min: 20, name: '20 o más unidades' }, { min: 5, name: '5 a 19 unidades' }, { min: 1, name: '1 a 4 unidades' }];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var rawFetch = window.fetch.bind(window);
  var cache = {};
  var busy = null;

  function json(url, body) {
    var o = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } };
    return rawFetch(ROOT + url, o).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'error'); e.data = j; throw e; } return j; });
    });
  }
  function tierName(q) { for (var i = 0; i < TIERS.length; i++) if (q >= TIERS[i].min) return TIERS[i].name; return TIERS[TIERS.length - 1].name; }
  function isTiered(item) { return (item.options_with_values || []).some(function (o) { return o.name === OPT; }); }
  function variantsOf(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return json('products/' + handle + '.js').then(function (p) {
      var idx = -1;
      (p.options || []).forEach(function (o, i) { if ((o.name || o) === OPT) idx = i; });
      var map = {};
      if (idx > -1) p.variants.forEach(function (v) { map[v.options[idx]] = v; });
      cache[handle] = map;
      return map;
    });
  }
  function cleanProps(p) {
    var o = {};
    Object.keys(p || {}).forEach(function (k) { if (p[k] !== null && p[k] !== '') o[k] = p[k]; });
    return o;
  }

  /* Devuelve true si tuvo que cambiar algo. */
  function normalize() {
    if (busy) return busy.then(normalize);
    busy = json('cart.js').then(function (cart) {
      var groups = {};
      cart.items.forEach(function (it) {
        if (!isTiered(it)) return;
        (groups[it.product_id] = groups[it.product_id] || { handle: it.handle, items: [], qty: 0 });
        groups[it.product_id].items.push(it);
        groups[it.product_id].qty += it.quantity;
      });
      var ids = Object.keys(groups);
      if (!ids.length) return false;
      return Promise.all(ids.map(function (id) {
        var g = groups[id];
        return variantsOf(g.handle).then(function (map) {
          var want = map[tierName(g.qty)];
          if (!want) return [];
          return g.items.filter(function (it) { return it.variant_id !== want.id; })
            .map(function (it) { return { key: it.key, from: it, add: { id: want.id, quantity: it.quantity, properties: cleanProps(it.properties) } }; });
        }).catch(function () { return []; });
      })).then(function (lists) {
        var moves = [].concat.apply([], lists);
        if (!moves.length) return false;
        var updates = {};
        moves.forEach(function (m) { updates[m.key] = 0; });
        return json('cart/update.js', { updates: updates })
          .then(function () { return json('cart/add.js', { items: moves.map(function (m) { return m.add; }) }); })
          .catch(function (e) {
            /* Si no se pudo agregar, se reponen las líneas originales para no perder nada. */
            return json('cart/add.js', { items: moves.map(function (m) { return { id: m.from.variant_id, quantity: m.from.quantity, properties: cleanProps(m.from.properties) }; }) })
              .catch(function () {}).then(function () { throw e; });
          })
          .then(function () { return true; });
      });
    }).catch(function (e) { if (window.console) console.warn('[NX] tramos:', e && e.message); return false; });
    var p = busy;
    p.then(function () { busy = null; }, function () { busy = null; });
    return p;
  }

  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function refreshUI() {
    if (onCartPage()) { location.reload(); return; }
    rawFetch(ROOT + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var parse = function (html, sel) { var d = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
      var drawer = document.getElementById('CartDrawer');
      if (drawer && s['cart-drawer']) { var h = parse(s['cart-drawer'], '#CartDrawer'); if (h !== null) drawer.innerHTML = h; }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && s['cart-icon-bubble']) { var b = parse(s['cart-icon-bubble'], '.shopify-section'); if (b !== null) bubble.innerHTML = b; }
    }).catch(function () {});
  }

  /* Después de cambios del carrito hechos por el tema (Dawn). El script de cantidades del tema recarga la página
     por su cuenta (window.quantityUpdateInProgress): en ese caso se normaliza al cargar. */
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { normalize().then(function (ch) { if (ch) refreshUI(); }); }, 350);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = rawFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && !window.quantityUpdateInProgress) {
      p.then(function (r) { if (r.ok) schedule(); }, function () {});
    }
    return p;
  };

  /* Antes de pagar: se corrige el tramo y, si algo cambió, se muestra el carrito actualizado. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], #CartDrawer-Checkout');
    if (!b || b.getAttribute('data-nx-ok') === '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    b.setAttribute('aria-busy', 'true');
    normalize().then(function (changed) {
      if (changed) { location.href = ROOT + 'cart'; return; }
      b.setAttribute('data-nx-ok', '1');
      b.removeAttribute('aria-busy');
      b.click();
      setTimeout(function () { b.removeAttribute('data-nx-ok'); }, 4000);
    });
  }, true);

  /* Aviso breve en el carrito. */
  function cartNote() {
    if (!onCartPage() || document.querySelector('.nx-cart-note')) return;
    var host = document.querySelector('#main-cart-footer .cart__blocks, .cart__footer, #main-cart-items');
    if (!host) return;
    var p = document.createElement('p');
    p.className = 'nx-cart-note';
    p.textContent = 'Precios por tramo: se calculan con el total de unidades de cada prenda, sumando tallas y colores (1–4, 5–19 y 20 o más). Valores netos; el IVA se agrega al pagar.';
    p.style.cssText = 'margin:1.2rem 0 0;padding:1rem 1.2rem;border-left:3px solid #4DA6E6;background:#f3f8fc;color:#001931;font-size:1.25rem;line-height:1.5';
    host.appendChild(p);
  }

  // El pie del carrito del tema usa una clave de idioma que no existe (sections.cart.taxes_and_shipping_at_checkout).
  function fixMissingText() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeValue.indexOf('Translation missing') > -1 && n.nodeValue.indexOf('taxes_and_shipping') > -1) n.nodeValue = 'Impuestos y envío se calculan en la pantalla de pago.';
    }
  }

  window.NXCart = { normalize: normalize };
  function start() {
    cartNote();
    fixMissingText();
    var n = +(document.currentScript && document.currentScript.getAttribute('data-count')) || 0;
    var el = document.querySelector('script[data-nx-cart]');
    if (el) n = +el.getAttribute('data-count') || 0;
    if (n > 0) normalize().then(function (ch) { if (ch) refreshUI(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
